import { useGetApiWorkspaceGet } from "@/API";
import { Breadcrumbs, Group, Text } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "@tanstack/react-router";
import { BotProviderList } from "./BotProviderList";
import { AppBreadcrumbs } from "@/Components/AppBreadcrumbs";

export function BotProviderIndex() {
    const { workspaceId } = useParams({ from: "/workspace/$workspaceId/botProvider/" })
    const workspace = useGetApiWorkspaceGet({ id: workspaceId })
    const queryClient = useQueryClient()
    const navigate = useNavigate()

    return <>
        <AppBreadcrumbs
            items={[
                {
                    label: '工作空間列表',
                    linkProps: { to: '/workspace' },
                },
                {
                    label: workspace.data?.data.name ?? '',
                    linkProps: { to: '/workspace/$workspaceId', params: { workspaceId } },
                },
                {
                    label: '機器人串接',
                    active: true,
                }
            ]}
        />
        <BotProviderList workspaceId={workspaceId} />
    </>
}